import store from 'store';

/**
 * This removes amplify items stores in local storage.
 * We previously allowed Amplify to store use session info in localstorage.
 * This is Amplify's default.
 * We now make it use sessionStorage so that sessions do not persist.
 */
export function clearAmplifyLocalStorage() {
  store.each((value, namespace) => {
    if (
      namespace.includes('CognitoIdentityServiceProvider') ||
      namespace.includes('ajs_anonymous_id') ||
      namespace.includes('ajs_group_properties') ||
      namespace.includes('ajs_group_id') ||
      namespace.includes('ajs_user_traits') ||
      namespace.includes('ajs_user_id') ||
      namespace.includes('ajs_anonymous_id') ||
      namespace.includes('aws.cognito.identity-id') ||
      namespace.includes('amplify-react-auth-source') ||
      namespace.includes('amplify-signin-with-hostedUI')
    ) {
      store.remove(namespace);
    }
  });
}
